import React from 'react';
import { Link } from "react-router-dom";
import styles from './Footer.module.css';
import Brand from "../navbar/Blockenzyme.svg";
import { FaLinkedinIn, FaTwitter, FaFacebookF } from "react-icons/fa";
import { AiFillInstagram } from "react-icons/ai";
import { FiYoutube } from "react-icons/fi";

const footerLinks = [
  {
    title: "Company",
    links: [
      { label: "About Us", to: "/about" },
      { label: "Blog", to: "#" },
      { label: "Careers", to: "#" },
      { label: "Press", to: "#" },
    ],
  },
  {
    title: "For Job Seekers",
    links: [
      { label: "Find Jobs", to: "/find-jobs" },
      { label: "Browse Categories", to: "/find-jobs" },
      { label: "Career Resources", to: "#" },
      { label: "Resume Tips", to: "#" },
    ],
  },
  {
    title: "For Employers",
    links: [
      { label: "Post a Job", to: "/hire-employees" },
      { label: "Employer Centre", to: "/hire-employees" },
      { label: "Pricing Plans", to: "/hire-employees" },
      { label: "Hire at Scale", to: "#" },
    ],
  },
  {
    title: "Support",
    links: [
      { label: "Help Centre", to: "#" },
      { label: "Contact Us", to: "#" },
      { label: "Terms of Use", to: "#" },
      { label: "Privacy Policy", to: "#" },
    ],
  },
];

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.footerBody}>
        {/* Brand Column */}
        <div className={styles.brandCol}>
          <div className={styles.logoWrap}>
            <img src={Brand} alt="Blockenzyme" className={styles.brandName} />
          </div>
          <p className={styles.brandDesc}>
            India's fastest-growing recruitment platform, connecting talented professionals with top employers every day.
          </p>
          <div className={styles.socialRow}>
            <a href="#" className={styles.socialIcon} aria-label="Instagram"><AiFillInstagram /></a>
            <a href="#" className={styles.socialIcon} aria-label="Facebook"><FaFacebookF /></a>
            <a href="#" className={styles.socialIcon} aria-label="LinkedIn"><FaLinkedinIn /></a>
            <a href="#" className={styles.socialIcon} aria-label="Twitter"><FaTwitter /></a>
            <a href="#" className={styles.socialIcon} aria-label="YouTube"><FiYoutube /></a>
          </div>
        </div>

        {/* Link Columns */}
        {footerLinks.map((col) => (
          <div key={col.title} className={styles.linkCol}>
            <h4 className={styles.linkColTitle}>{col.title}</h4>
            {col.links.map((link) => (
              <Link key={link.label} to={link.to} className={styles.footerLink}>
                {link.label}
              </Link>
            ))}
          </div>
        ))}
      </div>

      <div className={styles.bottomBar}>
        <div className={styles.bottomBarInner}>
          <span className={styles.copyright}>
            © 2008–{year} Blockenzyme, Inc. All rights reserved.
          </span>
          <div className={styles.bottomLinks}>
            <a href="#" className={styles.bottomLink}>Terms</a>
            <a href="#" className={styles.bottomLink}>Privacy</a>
            <a href="#" className={styles.bottomLink}>Cookies</a>
            <a href="#" className={styles.bottomLink}>Accessibility</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
